import { takeLatest, put, call } from "redux-saga/effects";
import {
  setOccupantBegin,
  setOccupantError,
  setOccupantSuccess,
} from "./slice";
import { selectOccupantOption } from "./actions";
import { apiGet } from "api/callApi";

function* setOccupantOption(val) {
  yield put(setOccupantBegin());
  try {
    const id = val.payload;
    const response = yield call(
      apiGet,
      `/v1/getoccupantoptions?projectId=${id}`,
      false
    );
    yield put(setOccupantSuccess({ newData: response.data }));
  } catch (error) {
    yield put(setOccupantError(error));
  }
}

export function* watchsetOccupantOption() {
  yield takeLatest(selectOccupantOption.type, setOccupantOption);
}
